const TUTORIAL_DISMISSED_KEY = 'pathways-tutorial-dismissed';

export const isTutorialDismissed = (): boolean => {
  try {
    return localStorage.getItem(TUTORIAL_DISMISSED_KEY) === 'true';
  } catch {
    return false;
  }
};

export const dismissTutorial = (): void => {
  try {
    localStorage.setItem(TUTORIAL_DISMISSED_KEY, 'true');
  } catch {
    // Silently fail if localStorage is unavailable
  }
};

export const resetTutorial = (): void => {
  try {
    localStorage.removeItem(TUTORIAL_DISMISSED_KEY);
  } catch {
    // Silently fail if localStorage is unavailable
  }
};